import React from 'react';

const AddUser = (
  <svg
    className='svg-icon-adduser'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='32' height='32' rx='16' fill='#E5F0F7' />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M10.4219 11.8332C10.4219 13.7508 11.9634 16.0004 13.8644 16.0004C15.7653 16.0004 17.3068 13.7508 17.3068 11.8332V11.1387C17.3068 9.22107 15.7653 7.66602 13.8644 7.66602C11.9634 7.66602 10.4219 9.22107 10.4219 11.1387V11.8332ZM16.5336 21.4712C16.1446 21.8657 15.9298 22.388 15.9298 22.9436V22.9457H7.66797V20.1898C7.66797 19.2987 8.22564 18.5035 9.06285 18.218C10.1954 17.8326 11.9201 17.3895 13.8644 17.3895C15.8087 17.3895 17.5333 17.8326 18.6659 18.218C18.9275 18.3069 19.1568 18.45 19.3551 18.6257L16.5336 21.4712ZM21.1578 18.8301C21.1669 18.8256 21.1782 18.8234 21.1919 18.8234H21.6441C21.6843 18.8234 21.7044 18.8426 21.7044 18.881V21.1424H23.9503C23.9905 21.1424 24.0106 21.1616 24.0106 21.2V21.6321C24.0106 21.6571 24.002 21.674 23.9849 21.6827C23.9759 21.6871 23.9646 21.6894 23.9509 21.6894H21.705V21.6897H23.9503C23.9643 21.6897 23.9758 21.6873 23.9849 21.6827C24.0024 21.6741 24.0112 21.6571 24.0112 21.6317V21.1996C24.0112 21.1612 23.9911 21.142 23.9509 21.142H21.705V18.8807C21.705 18.8423 21.6849 18.8231 21.6447 18.8231H21.1925C21.1785 18.8231 21.167 18.8254 21.1578 18.8301ZM21.1578 18.8301C21.1403 18.8387 21.1316 18.8557 21.1316 18.881V21.142H21.1322V18.8807C21.1322 18.8557 21.1408 18.8388 21.1578 18.8301ZM21.6447 24.0083C21.6584 24.0083 21.6697 24.0061 21.6787 24.0016C21.6696 24.0063 21.6581 24.0086 21.6441 24.0086H21.1919C21.1517 24.0086 21.1316 23.9894 21.1316 23.951V21.6897H18.8857C18.8455 21.6897 18.8254 21.6705 18.8254 21.6321V21.2C18.8254 21.1746 18.8341 21.1576 18.8517 21.149C18.8346 21.1577 18.826 21.1746 18.826 21.1996V21.6317C18.826 21.6702 18.8461 21.6894 18.8863 21.6894H21.1322V23.9507C21.1322 23.9891 21.1523 24.0083 21.1925 24.0083H21.6447ZM20.8075 20.8183V18.881C20.8075 18.808 20.8274 18.6947 20.9228 18.6035C21.0154 18.515 21.1254 18.4993 21.1919 18.4993H21.6441C21.7105 18.4993 21.8205 18.515 21.9132 18.6035C22.0086 18.6947 22.0284 18.808 22.0284 18.881V20.8183H23.9503C24.0167 20.8183 24.1267 20.8339 24.2194 20.9225C24.3148 21.0136 24.3346 21.127 24.3346 21.2V21.6321C24.3346 21.7051 24.3148 21.8184 24.2194 21.9096C24.1267 21.9981 24.0167 22.0138 23.9503 22.0138H22.0284V23.951C22.0284 24.024 22.0086 24.1373 21.9132 24.2285C21.8205 24.317 21.7105 24.3327 21.6441 24.3327H21.1919C21.1254 24.3327 21.0154 24.317 20.9228 24.2285C20.8274 24.1373 20.8075 24.024 20.8075 23.951V22.0138H18.8857C18.8192 22.0138 18.7092 21.9981 18.6166 21.9096C18.5212 21.8184 18.5013 21.7051 18.5013 21.6321V21.2C18.5013 21.127 18.5212 21.0136 18.6166 20.9225C18.7092 20.8339 18.8192 20.8183 18.8857 20.8183H20.8075Z'
      fill='#0066B3'
    />
  </svg>
);

const View = (
  <svg
    className='svg-icon-view'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='32' height='32' rx='16' fill='#F2FBFE' />
    <path
      d='M13.7339 16C13.7339 16.5802 13.9643 17.1366 14.3746 17.5468C14.7848 17.957 15.3412 18.1875 15.9214 18.1875C16.5015 18.1875 17.0579 17.957 17.4682 17.5468C17.8784 17.1366 18.1089 16.5802 18.1089 16C18.1089 15.4198 17.8784 14.8634 17.4682 14.4532C17.0579 14.043 16.5015 13.8125 15.9214 13.8125C15.3412 13.8125 14.7848 14.043 14.3746 14.4532C13.9643 14.8634 13.7339 15.4198 13.7339 16ZM24.4018 15.4961C22.5503 11.5957 19.7515 9.63281 15.9995 9.63281C12.2456 9.63281 9.44872 11.5957 7.59716 15.498C7.52289 15.6553 7.48438 15.8271 7.48438 16.001C7.48438 16.1749 7.52289 16.3466 7.59716 16.5039C9.44872 20.4043 12.2475 22.3672 15.9995 22.3672C19.7534 22.3672 22.5503 20.4043 24.4018 16.502C24.5522 16.1855 24.5522 15.8184 24.4018 15.4961ZM15.9214 19.4375C14.0229 19.4375 12.4839 17.8984 12.4839 16C12.4839 14.1016 14.0229 12.5625 15.9214 12.5625C17.8198 12.5625 19.3589 14.1016 19.3589 16C19.3589 17.8984 17.8198 19.4375 15.9214 19.4375Z'
      fill='#00AEEF'
    />
  </svg>
);

const Edit = (
  <svg
    className='svg-icon-edit'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='32' height='32' rx='16' fill='#F2FBFE' />
    <path
      d='M23.1875 22.3281H8.8125C8.4668 22.3281 8.1875 22.6074 8.1875 22.9531V23.6562C8.1875 23.7422 8.25781 23.8125 8.34375 23.8125H23.6562C23.7422 23.8125 23.8125 23.7422 23.8125 23.6562V22.9531C23.8125 22.6074 23.5332 22.3281 23.1875 22.3281ZM11.0332 20.6875C11.0723 20.6875 11.1113 20.6836 11.1504 20.6777L14.4355 20.1016C14.4746 20.0938 14.5117 20.0762 14.5391 20.0469L22.8184 11.7676C22.8365 11.7495 22.8508 11.728 22.8606 11.7044C22.8704 11.6808 22.8755 11.6555 22.8755 11.6299C22.8755 11.6043 22.8704 11.579 22.8606 11.5553C22.8508 11.5317 22.8365 11.5103 22.8184 11.4922L19.5723 8.24414C19.5352 8.20703 19.4863 8.1875 19.4336 8.1875C19.3809 8.1875 19.332 8.20703 19.2949 8.24414L11.0156 16.5234C10.9863 16.5527 10.9688 16.5879 10.9609 16.627L10.3848 19.9121C10.3658 20.0167 10.3726 20.1244 10.4045 20.2258C10.4365 20.3273 10.4928 20.4193 10.5684 20.4941C10.6973 20.6191 10.8594 20.6875 11.0332 20.6875Z'
      fill='#00AEEF'
    />
  </svg>
);

const Copy = (
  <svg
    className='svg-icon-copy'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='32' height='32' rx='16' fill='#F2FBFE' />

    <path
      d='M 21.755 8.663 L 9.755 8.663 C 9.341 8.663 9.005 8.998 9.005 9.413 L 9.005 21.851 C 9.005 22.051 9.085 22.24 9.226 22.381 L 13.287 26.443 C 13.339 26.494 13.398 26.536 13.461 26.572 L 13.461 26.616 L 13.559 26.616 C 13.641 26.647 13.728 26.663 13.817 26.663 L 21.755 26.663 C 22.17 26.663 22.505 26.328 22.505 25.913 L 22.505 9.413 C 22.505 8.998 22.17 8.663 21.755 8.663 Z M 13.459 24.23 L 11.441 22.21 L 13.459 22.21 L 13.459 24.23 Z M 20.818 24.976 L 14.959 24.976 L 14.959 21.647 C 14.959 21.129 14.539 20.71 14.021 20.71 L 10.693 20.71 L 10.693 10.351 L 20.818 10.351 L 20.818 24.976 Z'
      fill='#1890FF'
      style={{
        transformBox: 'fill-box',
        transformOrigin: '50% 50%',
      }}
    ></path>

    <path
      d='M 23.825 6.755 L 11.262 6.755 C 11.159 6.755 11.075 6.839 11.075 6.943 L 11.075 8.255 C 11.075 8.358 11.159 8.443 11.262 8.443 L 22.887 8.443 L 22.887 24.568 C 22.887 24.671 22.972 24.755 23.075 24.755 L 24.387 24.755 C 24.49 24.755 24.575 24.671 24.575 24.568 L 24.575 7.505 C 24.575 7.09 24.239 6.755 23.825 6.755 Z'
      fill='#1890FF'
      style={{
        transformBox: 'fill-box',
        transformOrigin: '50% 50%',
      }}
    ></path>

    <path
      d='M 21.755 8.663 L 9.755 8.663 C 9.341 8.663 9.005 8.998 9.005 9.413 L 9.005 21.851 C 9.005 22.051 9.085 22.24 9.226 22.381 L 13.287 26.443 C 13.339 26.494 13.398 26.536 13.461 26.572 L 13.461 26.616 L 13.559 26.616 C 13.641 26.647 13.728 26.663 13.817 26.663 L 21.755 26.663 C 22.17 26.663 22.505 26.328 22.505 25.913 L 22.505 9.413 C 22.505 8.998 22.17 8.663 21.755 8.663 Z M 13.459 24.23 L 11.441 22.21 L 13.459 22.21 L 13.459 24.23 Z M 20.818 24.976 L 14.959 24.976 L 14.959 21.647 C 14.959 21.129 14.539 20.71 14.021 20.71 L 10.693 20.71 L 10.693 10.351 L 20.818 10.351 L 20.818 24.976 Z'
      fill='#1890FF'
      style={{
        transformBox: 'fill-box',
        transformOrigin: '50% 50%',
      }}
    ></path>
  </svg>
);

const Delete = (
  <svg
    className='svg-icon-delete'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='32' height='32' rx='16' fill='#FFF1F0' />
    <path
      d='M22.875 11H20.375V9.4375C20.375 8.74805 19.8145 8.1875 19.125 8.1875H12.875C12.1855 8.1875 11.625 8.74805 11.625 9.4375V11H9.125C8.7793 11 8.5 11.2793 8.5 11.625V12.25C8.5 12.3359 8.57031 12.4062 8.65625 12.4062H9.83594L10.3184 22.6211C10.3496 23.2871 10.9004 23.8125 11.5664 23.8125H20.4336C21.1016 23.8125 21.6504 23.2891 21.6816 22.6211L22.1641 12.4062H23.3438C23.4297 12.4062 23.5 12.3359 23.5 12.25V11.625C23.5 11.2793 23.2207 11 22.875 11ZM18.9688 11H13.0312V9.59375H18.9688V11Z'
      fill='#F5222D'
    />
  </svg>
);
const DeleteOrange = (
  <svg
    className='svg-icon-delete'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='32' height='32' rx='16' fill='#fff8f0' />
    <path
      d='M22.875 11H20.375V9.4375C20.375 8.74805 19.8145 8.1875 19.125 8.1875H12.875C12.1855 8.1875 11.625 8.74805 11.625 9.4375V11H9.125C8.7793 11 8.5 11.2793 8.5 11.625V12.25C8.5 12.3359 8.57031 12.4062 8.65625 12.4062H9.83594L10.3184 22.6211C10.3496 23.2871 10.9004 23.8125 11.5664 23.8125H20.4336C21.1016 23.8125 21.6504 23.2891 21.6816 22.6211L22.1641 12.4062H23.3438C23.4297 12.4062 23.5 12.3359 23.5 12.25V11.625C23.5 11.2793 23.2207 11 22.875 11ZM18.9688 11H13.0312V9.59375H18.9688V11Z'
      fill='#fc5b32'
    />
  </svg>
);

const Logout = (
  <svg viewBox='3 3 18.3281 18' width='18.3281' height='18'>
    <path
      d='M20.8195 17.7516H19.5586C19.4602 17.7516 19.3781 17.8336 19.3781 17.932V19.3805H4.61953V4.61953H19.3805V6.06797C19.3805 6.16641 19.4625 6.24844 19.5609 6.24844H20.8219C20.9203 6.24844 21.0023 6.16875 21.0023 6.06797V3.71953C21.0023 3.32109 20.6813 3 20.2828 3H3.71953C3.32109 3 3 3.32109 3 3.71953V20.2805C3 20.6789 3.32109 21 3.71953 21H20.2805C20.6789 21 21 20.6789 21 20.2805V17.932C21 17.8312 20.918 17.7516 20.8195 17.7516ZM21.1406 11.1562H13.7812V9.375C13.7812 9.21797 13.5984 9.12891 13.4766 9.22734L10.1508 11.8523C10.1284 11.8699 10.1102 11.8923 10.0978 11.9179C10.0853 11.9435 10.0788 11.9715 10.0788 12C10.0788 12.0285 10.0853 12.0565 10.0978 12.0821C10.1102 12.1077 10.1284 12.1301 10.1508 12.1477L13.4766 14.7727C13.6008 14.8711 13.7812 14.782 13.7812 14.625V12.8438H21.1406C21.2437 12.8438 21.3281 12.7594 21.3281 12.6562V11.3438C21.3281 11.2406 21.2437 11.1562 21.1406 11.1562Z'
      fill='#8C8C8C'
      transform='matrix(1, 0, 0, 1, 2.220446049250313e-16, 0)'
    ></path>
  </svg>
);

const EditNoBackground = (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M20.625 19.5938H3.375C2.96016 19.5938 2.625 19.9289 2.625 20.3438V21.1875C2.625 21.2906 2.70937 21.375 2.8125 21.375H21.1875C21.2906 21.375 21.375 21.2906 21.375 21.1875V20.3438C21.375 19.9289 21.0398 19.5938 20.625 19.5938ZM6.03984 17.625C6.08672 17.625 6.13359 17.6203 6.18047 17.6133L10.1227 16.9219C10.1695 16.9125 10.2141 16.8914 10.2469 16.8563L20.182 6.92109C20.2038 6.89941 20.221 6.87366 20.2328 6.8453C20.2445 6.81695 20.2506 6.78656 20.2506 6.75586C20.2506 6.72516 20.2445 6.69477 20.2328 6.66642C20.221 6.63806 20.2038 6.61231 20.182 6.59063L16.2867 2.69297C16.2422 2.64844 16.1836 2.625 16.1203 2.625C16.057 2.625 15.9984 2.64844 15.9539 2.69297L6.01875 12.6281C5.98359 12.6633 5.9625 12.7055 5.95312 12.7523L5.26172 16.6945C5.23892 16.8201 5.24707 16.9493 5.28545 17.071C5.32384 17.1927 5.39132 17.3032 5.48203 17.393C5.63672 17.543 5.83125 17.625 6.03984 17.625Z'
      fill='#8C8C8C'
    />
  </svg>
);

const Checked = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path
      fill='#8C8C8C'
      d='M 19.980469 5.9902344 A 1.0001 1.0001 0 0 0 19.292969 6.2929688 L 9 16.585938 L 5.7070312 13.292969 A 1.0001 1.0001 0 1 0 4.2929688 14.707031 L 8.2929688 18.707031 A 1.0001 1.0001 0 0 0 9.7070312 18.707031 L 20.707031 7.7070312 A 1.0001 1.0001 0 0 0 19.980469 5.9902344 z'
    ></path>
  </svg>
);

const Cancel = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='24'
    height='24'
    fill='#8c8c8c'
    viewBox='0 0 30 30'
  >
    <path d='M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16.414,15 c0,0,3.139,3.139,3.293,3.293c0.391,0.391,0.391,1.024,0,1.414c-0.391,0.391-1.024,0.391-1.414,0C18.139,19.554,15,16.414,15,16.414 s-3.139,3.139-3.293,3.293c-0.391,0.391-1.024,0.391-1.414,0c-0.391-0.391-0.391-1.024,0-1.414C10.446,18.139,13.586,15,13.586,15 s-3.139-3.139-3.293-3.293c-0.391-0.391-0.391-1.024,0-1.414c0.391-0.391,1.024-0.391,1.414,0C11.861,10.446,15,13.586,15,13.586 s3.139-3.139,3.293-3.293c0.391-0.391,1.024-0.391,1.414,0c0.391,0.391,0.391,1.024,0,1.414C19.554,11.861,16.414,15,16.414,15z'></path>
  </svg>
);

const EyeBall = (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M22.0822 11.3953C19.8603 6.71484 16.5017 4.35938 11.9994 4.35938C7.49472 4.35938 4.13847 6.71484 1.91659 11.3977C1.82747 11.5864 1.78125 11.7925 1.78125 12.0012C1.78125 12.2099 1.82747 12.416 1.91659 12.6047C4.13847 17.2852 7.49706 19.6406 11.9994 19.6406C16.5041 19.6406 19.8603 17.2852 22.0822 12.6023C22.2627 12.2227 22.2627 11.782 22.0822 11.3953ZM11.9994 17.9531C8.21893 17.9531 5.45097 16.0359 3.49862 12C5.45097 7.96406 8.21893 6.04688 11.9994 6.04688C15.7799 6.04688 18.5478 7.96406 20.5002 12C18.5502 16.0359 15.7822 17.9531 11.9994 17.9531ZM11.9057 7.875C9.62753 7.875 7.78065 9.72188 7.78065 12C7.78065 14.2781 9.62753 16.125 11.9057 16.125C14.1838 16.125 16.0307 14.2781 16.0307 12C16.0307 9.72188 14.1838 7.875 11.9057 7.875ZM11.9057 14.625C10.4549 14.625 9.28065 13.4508 9.28065 12C9.28065 10.5492 10.4549 9.375 11.9057 9.375C13.3564 9.375 14.5307 10.5492 14.5307 12C14.5307 13.4508 13.3564 14.625 11.9057 14.625Z'
      fill='#8c8c8c'
    />
  </svg>
);

const Download = (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.85234 12.4922C8.86988 12.5146 8.89229 12.5327 8.91788 12.5452C8.94346 12.5577 8.97154 12.5641 9 12.5641C9.02846 12.5641 9.05654 12.5577 9.08212 12.5452C9.10771 12.5327 9.13012 12.5146 9.14766 12.4922L11.7727 9.17109C11.8687 9.04922 11.782 8.86875 11.625 8.86875H9.88828V0.9375C9.88828 0.834375 9.80391 0.75 9.70078 0.75H8.29453C8.19141 0.75 8.10703 0.834375 8.10703 0.9375V8.86641H6.375C6.21797 8.86641 6.13125 9.04688 6.22734 9.16875L8.85234 12.4922ZM17.5781 11.6719H16.1719C16.0688 11.6719 15.9844 11.7563 15.9844 11.8594V15.4688H2.01562V11.8594C2.01562 11.7563 1.93125 11.6719 1.82812 11.6719H0.421875C0.31875 11.6719 0.234375 11.7563 0.234375 11.8594V16.5C0.234375 16.9148 0.569531 17.25 0.984375 17.25H17.0156C17.4305 17.25 17.7656 16.9148 17.7656 16.5V11.8594C17.7656 11.7563 17.6812 11.6719 17.5781 11.6719Z'
      fill='#8c8c8c'
    />
  </svg>
);
const Export = (
  <>
    <img
      id='base64image'
      width={24}
      height={24}
      src='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9Imljb24iIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlLz48cG9seWdvbiBwb2ludHM9IjEzIDIxIDI2LjE3IDIxIDIzLjU5IDIzLjU5IDI1IDI1IDMwIDIwIDI1IDE1IDIzLjU5IDE2LjQxIDI2LjE3IDE5IDEzIDE5IDEzIDIxIi8+PHBhdGggZD0iTTIyLDE0VjEwYTEsMSwwLDAsMC0uMjktLjcxbC03LTdBMSwxLDAsMCwwLDE0LDJINEEyLDIsMCwwLDAsMiw0VjI4YTIsMiwwLDAsMCwyLDJIMjBhMiwyLDAsMCwwLDItMlYyNkgyMHYySDRWNGg4djZhMiwyLDAsMCwwLDIsMmg2djJabS04LTRWNC40MUwxOS41OSwxMFoiLz48cmVjdCBjbGFzcz0iY2xzLTEiIGRhdGEtbmFtZT0iJmx0O1RyYW5zcGFyZW50IFJlY3RhbmdsZSZndDsiIGhlaWdodD0iMzIiIGlkPSJfVHJhbnNwYXJlbnRfUmVjdGFuZ2xlXyIgd2lkdGg9IjMyIi8+PC9zdmc+'
    />
    {/* <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.8195 17.7516H19.5586C19.4602 17.7516 19.3781 17.8336 19.3781 17.932V19.3805H4.61953V4.61953H19.3805V6.06797C19.3805 6.16641 19.4625 6.24844 19.5609 6.24844H20.8219C20.9203 6.24844 21.0023 6.16875 21.0023 6.06797V3.71953C21.0023 3.32109 20.6813 3 20.2828 3H3.71953C3.32109 3 3 3.32109 3 3.71953V20.2805C3 20.6789 3.32109 21 3.71953 21H20.2805C20.6789 21 21 20.6789 21 20.2805V17.932C21 17.8312 20.918 17.7516 20.8195 17.7516ZM21.2555 11.8523L17.9297 9.22734C17.8055 9.12891 17.625 9.21797 17.625 9.375V11.1562H10.2656C10.1625 11.1562 10.0781 11.2406 10.0781 11.3438V12.6562C10.0781 12.7594 10.1625 12.8438 10.2656 12.8438H17.625V14.625C17.625 14.782 17.8078 14.8711 17.9297 14.7727L21.2555 12.1477C21.2779 12.1301 21.296 12.1077 21.3085 12.0821C21.3209 12.0565 21.3274 12.0285 21.3274 12C21.3274 11.9715 21.3209 11.9435 21.3085 11.9179C21.296 11.8923 21.2779 11.8699 21.2555 11.8523Z'
        fill='#323232'
      />
    </svg> */}
    {/* <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z'
        fill='#00aeef'
      />
      <rect
        class='cls-1'
        data-name='&lt;Transparent Rectangle&gt;'
        height='32'
        id='_Transparent_Rectangle_'
        width='32'
      />
    </svg> */}
  </>
);

const ViewUser = (
<svg
    className='svg-icon-view'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='32' height='32' rx='16' fill='#F2FBFE' />
    <path
      d='M13.7339 16C13.7339 16.5802 13.9643 17.1366 14.3746 17.5468C14.7848 17.957 15.3412 18.1875 15.9214 18.1875C16.5015 18.1875 17.0579 17.957 17.4682 17.5468C17.8784 17.1366 18.1089 16.5802 18.1089 16C18.1089 15.4198 17.8784 14.8634 17.4682 14.4532C17.0579 14.043 16.5015 13.8125 15.9214 13.8125C15.3412 13.8125 14.7848 14.043 14.3746 14.4532C13.9643 14.8634 13.7339 15.4198 13.7339 16ZM24.4018 15.4961C22.5503 11.5957 19.7515 9.63281 15.9995 9.63281C12.2456 9.63281 9.44872 11.5957 7.59716 15.498C7.52289 15.6553 7.48438 15.8271 7.48438 16.001C7.48438 16.1749 7.52289 16.3466 7.59716 16.5039C9.44872 20.4043 12.2475 22.3672 15.9995 22.3672C19.7534 22.3672 22.5503 20.4043 24.4018 16.502C24.5522 16.1855 24.5522 15.8184 24.4018 15.4961ZM15.9214 19.4375C14.0229 19.4375 12.4839 17.8984 12.4839 16C12.4839 14.1016 14.0229 12.5625 15.9214 12.5625C17.8198 12.5625 19.3589 14.1016 19.3589 16C19.3589 17.8984 17.8198 19.4375 15.9214 19.4375Z'
      fill='#FC5B10'
      opacity={.75}
    />
  </svg>
)


export default {
  AddUser,
  Copy,
  Delete,
  Edit,
  View,
  Logout,
  EditNoBackground,
  Checked,
  Cancel,
  EyeBall,
  Download,
  Export,
  DeleteOrange,
  ViewUser
};
